import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";
const API_URL = `/decision_making_user`;


export const getAllDecisionMakingUser = async () => {
    try {
        const response = await api.get(API_URL);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des utilisateurs décisionnaires :", error);
    handleHttpError(error, "Impossible de charger les utilisateurs décisionnaires.");

    }
}

export const saveAllDecisionMakingUser = async (decisionMakingUserData) => {
    const url = `${API_URL}/all`;

    try {
        const response = await api.post(url, decisionMakingUserData);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l’enregistrement en masse des utilisateurs décisionnaires :", error);
        handleHttpError(error, "Échec de l’enregistrement des utilisateurs décisionnaires.");
    
    }
}
export const updateAllDecisionMakingUser = async (decisionMakingUserData) => {
    try {
        const response = await api.put(API_URL, decisionMakingUserData);
        return response.data;
    } catch (error) {
        console.error('Error fetching DecisionMakingUser:', error);
        console.error("Erreur lors de la mise à jour des utilisateurs décisionnaires :", error);
        handleHttpError(error, "Échec de la mise à jour des utilisateurs décisionnaires.");

    }
}

export const saveDecisionMakingUser = async (decisionMakingUserData) => {

    try {
        const response = await api.post(API_URL, decisionMakingUserData);
        return response.data;
    } catch (error) {
         console.error("Erreur lors de l’enregistrement d’un utilisateur décisionnaire :", error);
        handleHttpError(error, "Échec de l’enregistrement de l’utilisateur décisionnaire.");
        throw error;

    }
};
export const saveDecisionMakingUsers = async (decisionMakingUserData) => {

    try {
        const response = await api.post(url, decisionMakingUserData);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l’enregistrement de plusieurs utilisateurs décisionnaires :", error);
        handleHttpError(error, "Échec de l’enregistrement groupé des utilisateurs décisionnaires.");
        throw error;

    }
};
